import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import { CONSENT_CHANGE_EVENT, hasAnalyticsConsent } from "Utils/cookieConsent"

export const useGTMTracking = () => {
	const location = useLocation()

	useEffect(() => {
		const trackPageView = () => {
			if (!hasAnalyticsConsent()) return
			window.dataLayer = window.dataLayer || []
			window.dataLayer.push({
				event: 'virtual_pageview',
				page_path: location.pathname + location.search,
			})
		}
		trackPageView()
		window.addEventListener(CONSENT_CHANGE_EVENT, trackPageView)
		return () => window.removeEventListener(CONSENT_CHANGE_EVENT, trackPageView)
	}, [location])
}
